import { render, staticRenderFns } from "./ProjectBox.vue?vue&type=template&id=4ee371b2"
import script from "./ProjectBox.vue?vue&type=script&lang=ts"
export * from "./ProjectBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports